import React from 'react';
import { LargeText } from '@guryou/html-components';
import { IconButton } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { aiLinks } from './AiSidebar';
import MobileMenu from './components/MobileMenu';

const AiAppBar = ({ classes, open, handleDrawerOpen, isMobile }) => {
  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar>
        {!isMobile && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
        )}

        {isMobile && <MobileMenu links={aiLinks} />}
        <LargeText color="#f1f1f1" marginLeft={6}>
          Welcome to Guryou AI studio
        </LargeText>
      </Toolbar>
    </AppBar>
  );
};

export default AiAppBar;
